@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.overlay-container {
  width: 100%;
  height: 100%;
  position: absolute;
  align-items: center;
  display: flex;
  justify-content: center;
}

.overlay-pill {
  font-size: 20px;
  line-height: 25px;
  color: @insights-page--overlay--text-color;
  background-color: @insights-page--overlay--background-color;
  padding: 12px 24px;
  border-radius: 27px;
  border: 1px solid @insights-page--overlay--border-color;
  z-index: 1;
}
